function updateList(state, blueprints) {
  return Object.assign({}, state, {
    items: blueprints,
  });
}

function setCurrent(state, blueprint) {
  return Object.assign({}, state, {
    current: blueprint,
  });
}

function updateCurrentValues(state, data) {
  return Object.assign({}, state, {
    current: Object.assign({}, state.current, {
      values: Object.assign({},
          !state.current ? {} : state.current.values,
          data),
    }),
  });
}

function updateCurrentAudit(state, audit) {
  return Object.assign({}, state, {
    current: Object.assign({}, state.current, {
      new_audit: Object.assign({},
          !state.current ? {} : state.current.new_audit,
          audit),
    }),
  });
}

export default function(state = {}, action) {
  switch (action.type) {
    case 'BLUEPRINTS__UPDATE_LIST':
      return updateList(state, action.blueprints);
    case 'BLUEPRINTS__SET_CURRENT':
      return setCurrent(state, action.blueprint);
    case 'BLUEPRINTS__UPDATE_CURRENT_VALUES':
      return updateCurrentValues(state, action.data);
    case 'BLUEPRINTS__UPDATE_CURRENT_AUDIT':
      return updateCurrentAudit(state, action.audit);

  }
  return state;
}


// WEBPACK FOOTER //
// ./src/store/reducers/blueprints.js